export default __webpack_public_path__ + "static/features-image-4-30093f1e9812a5a1c8ea03bce0916261.png";